import Client from '../axiosClient'
const resource = '/payments';
const createPaymentResponse = '/payment_response_save';
const resourceInit = '/payments';


const directResource = '/direct_payments';
const directResourceInit = '/direct_payments';
const createDirectPayment = '/direct_response_save';
const addDirectPayment = '/add_direct_payment';


export default {
  directInit() {
    return Client.get(`${directResourceInit}`);
  },
  directget(payload) {
    if(payload) {
      return Client.get(`${directResource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${directResource}`);
  },

  createDirectPayment(payload){    
    return Client.post(`${createDirectPayment}`, payload);
  },

  addDirectPayment(payload){    
    return Client.post(`${addDirectPayment}`, payload);
  },

  
  init() {
    return Client.get(`${resourceInit}`);
  },
  

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  get(payload) {
    if(payload) {
      return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);
  },

  createPaymentResponse(payload){    
    return Client.post(`${createPaymentResponse}`, payload);
  },

};



// WEBPACK FOOTER //
// ./src/repositories/travel/PaymentRepository.js